import { Storage } from 'aws-amplify';
import { Fragment, useEffect, useRef, useState } from 'react';
import { ProgressBar } from 'react-bootstrap';
import { v4 as uuidv4 } from 'uuid';
import Resizer from 'react-image-file-resizer';

const AttachmentUploader = ({ getImageUrl, uploadImage, originalImageName, pastAttachment }) => {
    const [imgName, setImgName] = useState([])
    const [uploadProgress, setUploadProgress] = useState('')
    const [imageExist, setImageexist] = useState(false)

    const imagelist = originalImageName;
    const uuidarray = uploadImage;
    let image;

    // const isInitialMount = useRef(true);

    useEffect(() => { 
        if(pastAttachment && imagelist?.length == 0){
            const pastAttachmentlist = pastAttachment.split(',');
            for (let i = 0; i < pastAttachmentlist.length; i++) {
                imagelist.push(pastAttachmentlist[i].substring(44));
                uuidarray.push(pastAttachmentlist[i]);
            }
            setImgName([...imagelist]);
            getImageUrl(uuidarray, imagelist);
            setImageexist(true);
        }
    }, [pastAttachment])

    const resizeFile = (file) =>
        new Promise((resolve) => {
            Resizer.imageFileResizer(
            file,
            1200,
            900,
            'JPEG',
            80,
            0,
            (uri) => {
                resolve(uri);
            },
            'file'
            );
    });

    async function onChange(e) {
        if(e.target.files.length <= 10){
            for (let i = 0; i < e.target.files.length; i++) {
                const file = e.target.files[i]
                if(file.name.includes("jpg") || file.name.includes("jpeg") || file.name.includes("png") 
                || file.name.includes("pdf") || file.name.includes("mp4") || file.name.includes("mov") || file.name.includes("PDF")){
                    try {
                        if(file.name.includes("jpg") || file.name.includes("jpeg") || file.name.includes("png")){
                            image = await resizeFile(file);
                        }
                        else{
                            image = file;
                        }
                        if(imagelist?.length >9){
                            alert("Only a maximum of 10 files are allowed.");
                            setImgName([...imagelist]);
                            getImageUrl(uuidarray, imagelist);
                            setImageexist(true);
                            return;
                        }
                        // Set the file name beside the custom upload button if uploaded
                        imagelist.push(file.name);
        
                        //Upload the file selected
                        const uuidFileName = uuidv4() + '-hrcas3-' + file.name
                        uuidarray.push(uuidFileName);
                        await Storage.put(uuidFileName, image, {
                            progressCallback(progress) {
                                const loaded =  progress.loaded
                                const total = progress.total
                                let percent = Math.floor((loaded*100)/total)
        
                                if (percent < 100) {
                                    setUploadProgress(percent)
                                } else if (percent === 100) {
                                    setUploadProgress(100)
                                    setTimeout(() => {
                                        setUploadProgress('')
                                    }, 1000)
                                }
                            }
                        })
                        //Retrieve the signed URL of the uploaded file for preview
                        // const signedUrl = await Storage.get(uuidFileName)
        
                        // if(imageName) {
                        //     setImgName(imagelist)
                        // }
                    } catch(err) {
                            console.log(err)
                    }
                }
                else{
                    alert("The selected file is not allow to be uploaded.")
                    return;
                }
            }
            setImgName([...imagelist]);
            getImageUrl(uuidarray, imagelist);
            setImageexist(true);
        }
        else{
            alert("Only a maximum of 10 files are allowed.")
        }
    }

    async function onClick(index){
        if (index !== -1) {
            imagelist.splice(index, 1);
            uuidarray.splice(index, 1);
        }
        setImgName([...imagelist]);
        getImageUrl(uuidarray, imagelist);
    }

    return (
        <Fragment>
            { imageExist ?
                <Fragment>
                    <label className='btn btn-primary' style={{ width: '96%', display: 'inline-block' }}>
                        Choose File
                    <input
                        type='file'
                        multiple
                        onChange={onChange}
                        onClick={(event)=> { 
                            event.target.value = null
                       }}
                        accept='.pdf, .jpg, .jpeg, .png, .mp4, .mov, .PDF'
                        style={{ display: 'none', marginRight: '5px', width: '122px', color: 'transparent'}}
                        id='img'
                    />
                    </label>
                    {
                        imgName && imgName?.map((imagelists, index) =>
                        <label key={imagelists} htmlFor='img' style={{display: 'unset'}}>
                            <div className='row'>
                                <div className='col-sm-10'>
                                {imagelists.substring(0,20)+"..."}    
                                </div>
                                <div className='col-sm-2'>
                                <button type='button' className='removeattachmentbutton' onClick={()=>onClick(index)}>X</button>
                                </div>
                            </div>
                        </label>
                        )
                    }
                    {
                        (uploadProgress > 0 && uploadProgress < 100)?
                            <ProgressBar 
                                now={uploadProgress} 
                                label={`${uploadProgress}%`}
                                style={{marginTop: '5px'}}
                                animated 
                            />
                        :
                        uploadProgress === 100 ?
                            <ProgressBar 
                                className='custom-progress-bar'
                                now={uploadProgress} 
                                label={'100%'}
                                style={{marginTop: '5px', animation: 'none'}}
                                animated
                            />
                        :
                        null
                    }
                </Fragment>
                :
                <Fragment>
                    <label className='btn btn-primary' style={{ width: '96%', display: 'inline-block' }}>
                        Choose File
                    <input
                        type='file'
                        multiple
                        onChange={onChange}
                        onClick={(event)=> { 
                            event.target.value = null
                       }}
                        accept='.pdf, .jpg, .jpeg, .png, .mp4, .mov, .PDF'
                        style={{ display: 'none' }}
                        id='img'
                    />
                    </label>
                    {
                        imageExist ? imgName?.map((imagelists) =>
                        <div key={imagelists} htmlFor='img' style={{display: 'unset'}}>
                            <div className='row'>
                                <div className='col-sm-12'>
                                {imagelists.substring(0,20)+"..."}    
                                </div>
                                <div className='col-sm-1'>
                                <button type='button' className='removeattachmentbutton' onClick={onClick}>X</button>
                                </div>
                            </div>
                        </div>
                        )
                        :
                        'No file chosen (Only accepts pdf, jpg, jpeg, png, mp4 and mov files)'
                    }
                    {
                        (uploadProgress > 0 && uploadProgress < 100)?
                            <ProgressBar 
                                now={uploadProgress} 
                                label={`${uploadProgress}%`}
                                style={{marginTop: '5px'}}
                                animated 
                            />
                        :
                        uploadProgress === 100 ?
                            <ProgressBar 
                                className='custom-progress-bar'
                                now={uploadProgress} 
                                label={'100%'}
                                style={{marginTop: '5px', animation: 'none'}}
                                animated
                            />
                        :
                        null
                    }
                </Fragment>
            }
        </Fragment>
    )
}

export default AttachmentUploader
